import React, {
  useContext,
} from 'react';
import Divider from '@mui/material/Divider';
import InsurancePaymentPopover from 'pages/Dashboard/pages/Billing/Payments/EOBDialog/InsurancePaymentPopover';
import {
  WizardContext,
} from 'pages/Dashboard/pages/Billing/Payments/EOBDialog/wizardContext';
import Wrapper from 'pages/Dashboard/components/Input/Wrapper';
import {
  useFormContext,
} from 'react-hook-form';
import useUserInfo from 'pages/Dashboard/hooks/useUserInfo';
import UnpostedAmountTag from 'pages/Dashboard/pages/Billing/Payments/columns/UnpostedAmountTag';
import {
  roundNumber,
} from '@populateui/utils';
import clsx from 'clsx';

type Props = {
  readonly?: boolean;
};

export default function EOBPaymentInfo({ readonly = false }: Props) {
  const { allocated, isManual } = useContext(WizardContext);
  const { watch } = useFormContext();
  const insurancePaymentAmount = watch('insurancePayment.paymentMethod.paymentAmount');
  const userInfo = useUserInfo();
  const canEditInsurancePayment = isManual || userInfo?.flags?.mayEditAutopostedEOBs;
  const unallocated = roundNumber((insurancePaymentAmount ?? 0) - (allocated ?? 0));

  return (
    <div className="flex items-end justify-start w-full gap-4 px-1">
      <div className="flex flex-col">
        <h3 className="text-xs font-semibold text-gray-500">Payment</h3>
        <InsurancePaymentPopover readonly={readonly || !canEditInsurancePayment} />
      </div>
      <Divider
        flexItem
        orientation="vertical"
      />
      <Wrapper
        id="unallocated"
        label="Unposted"
      >
        <div className="flex items-center !h-8">
          <UnpostedAmountTag
            unallocated={unallocated}
            className={clsx('!font-bold', {
              '!text-gray-900': unallocated > 0,
              '!text-red-600': unallocated < 0,
            })}
          />
        </div>
      </Wrapper>
    </div>
  );
}
